import React from "react";
import CTAButton from "../components/molecules/CTAButtons";
import filters from "../models/filters";
import ManageStorage from "../utils/manageStorage";
import { FILTER_CHOICE, FILTER_RANGE } from "../constants/filterTypes";
import FilterChoice from "../components/FiltersChoice";
import FilterRange from "../components/FiltersRange";
import { SEE_RESULTS } from "../constants/routesPaths";
import FilterData from "../utils/FilterData";

import backgroundFigure from "../assets/svgs/background_figure.svg";
import Navbar from "../components/Navbar";
import { analytics } from "../firebase.config";
import Notifications from "../components/molecules/Notifications";
import { isMobile } from "react-device-detect";

// import Loading from "../components/Loading";

class Filters extends React.Component {
  storage = new ManageStorage();

  constructor(props) {
    super(props);
    const data = this.storage.data;

    const filterData = new FilterData();

    // llenarlo de los filters
    if (Object.keys(data).length === 0) {
      this.storage.items = filterData.initiateFiltersInStorage();
      // detectar cuales no existen e incluirlos
    } else {
      this.storage.items = {
        ...filterData.initiateFiltersInStorage(),
        ...data,
        ...{fur:[]}
      };
    }

    this.state = { ...this.storage.data, ...{showNotification: false}};
  }

  componentDidMount() {
    analytics.logEvent(`Page_Fitler`, {});
    window.scrollTo(0, 0);

    if (isMobile) {
      setTimeout(() => {
        this.setState({
          showNotification: true
        });

        setTimeout(() => {
          this.setState({
            showNotification: false
          });
        }, 5000);

      }, 2000);
    }
  }

  handleAction(action) {
    analytics.logEvent(`Action_Filter`, this.storage.data);
    this.props.history.push(SEE_RESULTS);
  }

  /**
   *
   * @param {int} value
   * @param {bool} isMultiple
   */
  handleChoice(value, isMultiple, filterObjKey) {
    const data = this.storage.data;

    if (isMultiple) {
      const selectedValues = this.state[filterObjKey];
      let findValue = (number) => {
        return number === value;
      };
      if (selectedValues.find(findValue)) {
        const indexValue = selectedValues.indexOf(value);
        selectedValues.splice(indexValue, indexValue);
      } else {
        if (typeof value === "object" && value.length === 0) {
          selectedValues.splice(0, selectedValues.length);
        } else {
          selectedValues.push(value);
        }
      }

      data[filterObjKey] = selectedValues;
      this.storage.items = data;
      this.setState({
        [filterObjKey]: selectedValues,
      });
    } else {
      let result;
      if (typeof value === "object" && value.length === 0) {
        result = [];
      } else {
        result = [value];
      }
      data[filterObjKey] = result;
      this.storage.items = data;
      this.setState({
        [filterObjKey]: result,
      });
    }
  }

  handleRangeSlider(values, filterObjKey) {
    const data = this.storage.data;

    data[filterObjKey] = values;
    this.storage.items = data;
    this.setState({
      [filterObjKey]: values,
    });
  }

  render() {
    return (
      <div className={"full_container"}>
        { isMobile && <Notifications
            text = {`🖐🏻 Haz scroll en la pantalla para ver los demás filtros 🖐🏻`}
            customClasses = {`${this.state.showNotification? 'notifications--active notifications--information notifications--active--changeBottom' : ''}`}
        /> }
        <div className={"filters"}>
          {/* <div className={"back-arrow"}>
            <Link to={"/"}>
              <img src={backImage} alt={"Boton atras"} />
            </Link>
          </div> */}
          <Navbar
            whiteVersion={true}
            customClasses={"navbar--relative no-options"}
          ></Navbar>
          <img
            className={
              "background-image-abstract background-image-abstract--right-top"
            }
            src={backgroundFigure}
            alt={"Imagen de fondo"}
          />
          <div className={"filters-notification notification"}>
            <div className={"notification-container notification--green"}>
              <p className={"notification-text--bold"}>
                ¡Cuéntanos un poco sobre la mascota que buscas!
              </p>
              <p className={"notification-text"}>
                De esta manera encontraremos tu opción ideal.
              </p>
            </div>
          </div>
          <div className={"filters_wrapper"}>
            {filters.map((filterObj) => {
              if (filterObj.type === FILTER_CHOICE) {
                return (
                  <FilterChoice
                    key={filterObj.key}
                    filterdata={filterObj}
                    objectfilter={this.state[filterObj.key]}
                    onClick={this.handleChoice.bind(this)}
                  ></FilterChoice>
                );
              } else if (filterObj.type === FILTER_RANGE) {
                return (
                  <FilterRange
                    key={filterObj.key}
                    filterdata={filterObj}
                    objectfilter={this.state[filterObj.key]}
                    onSlide={this.handleRangeSlider.bind(this)}
                  ></FilterRange>
                );
              }

              return <div></div>;
            })}
          </div>

          <div className={"button-wrapper button-wrapper--background"}>
            <CTAButton
              buttonText={"Encontrar a mi mascota"}
              onAction={this.handleAction.bind(this)}
              actionValue={true}
              image={"svgs/search_white_icon.svg"}
              position={"left"}
              customClasses={"ctabutton--bigger-maxwidth"}
            />
          </div>
        </div>
        {/* <Loading /> */}
        {/* <Footer /> */}
      </div>
    );
  }
}

export default Filters;
